<template>
  <v-card :flat="isModal ? true : false">
    <v-card-title class="pb-0">
      <h1 class="headline">
        Редактирование Индекса
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout column>
          <v-layout row>
            <v-flex xs6>
              <TitleTextField
                v-model="entity.code"
                :rules="[v => !!v || 'Поле обязательно к заполнению']"
                :readonly="false"
                :required="true"
                label="Индекс*"
                class="mx-2"
                @input="entityChange"
              />
            </v-flex>
            <v-flex xs6>
              <CountryReference
                v-model="entity.country"
                :rules="[v => !!v || '']"
                :clearable="true"
                label="Страна*"
                class="mx-2"
                @input="entityChange('country')"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            class="mb-3"
          >
            <v-flex xs4>
              <RegionReference
                v-model="entity.region"
                :rules="[v => !!v || '']"
                :clearable="true"
                label="Регион*"
                :country-id="entity.country ? entity.country.id : 0"
                class="mx-2"
                @input="entityChange('region')"
              />
            </v-flex>
            <v-flex xs4>
              <DistrictReference
                v-model="entity.district"
                :clearable="true"
                label="Область"
                :country-id="entity.country ? entity.country.id : 0"
                :region-id="entity.region ? entity.region.id : 0"
                class="mx-2 "
                @input="entityChange('district')"
              />
            </v-flex>
            <v-flex xs4>
              <CityReference
                v-model="entity.city"
                :rules="[v => !!v || '']"
                :clearable="true"
                label="Город*"
                :country-id="entity.country ? entity.country.id : 0"
                :region-id="entity.region ? entity.region.id : 0"
                :district-id="entity.district ? entity.district.id : 0"
                class="mx-2"
                @input="entityChange('city')"
              />
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout class="mt-3">
          <v-layout v-if="isConfirmed === false">
            <v-btn
              small
              color="primary"
              @click="saveAndClose"
            >
              Подтвердить
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-layout>

          <v-layout v-else>
            <v-btn
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              @click="submit(false)"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="!isModal"
              small
              color="primary"
              :disabled="!(isValid && isChanged) || entity.isRemoved || loading"
              @click="saveAndClose"
            >
              Сохранить и закрыть
            </v-btn>
            <v-btn
              small
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-layout>
        </v-layout>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
import CountryReference from "../countries/CountryReference.vue";
import CityReference from "../cities/CityReference.vue";
import { NestedEditorsEventBus } from "../../components/nested-editors/nested-editors-event-bus.js";
import RegionReference from "../regions//RegionReference.vue";
import DistrictReference from "../districts/DistrictReference.vue";
import * as locationsApi from "../../backend/locationsApi.js";

export default {
  components: {
    CountryReference,
    CityReference,
    RegionReference,
    DistrictReference,
  },
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      entity: {
        id: 0,
        country: null,
        district: null,
        region: null,
        city: null,
        code: "",
      },
      entityRestored: false,
      resource: "locations",
      isValid: false,
      isChanged: false,
      loading: false,
      index: null,
    };
  },
  computed: {
    inputLanguage() {
      return this.entity.country ? this.entity.country.inputLanguage : "";
    },
    isModal() {
      let parent = this.$parent;
      while (parent) {
        if (parent.$options._componentTag === "NestedEditors") {
          return true;
        }
        parent = parent.$parent;
      }
      return false;
    },
    isConfirmed() {
      if (Object.prototype.hasOwnProperty.call(this.entity, "isConfirmed")) {
        return this.entity.isConfirmed;
      }
    },
    isNew() {
      return +this.id ? false : true;
    },
  },
  created() {
    if (+this.id) {
      this.getData();
    }
  },
  mounted() {
    if (this.isModal) {
      NestedEditorsEventBus.$emit("modal-editor-mounted");
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      this.entity = await locationsApi.getLocation(this.resource, this.id);
      this.entityRestored = true;
      this.loading = false;
    },
    entityChange(entityName) {
      if (!this.entityRestored && !this.isModal && this.id != 0) {
        return;
      }
      switch (entityName) {
        case "country":
          this.entity.region = null;
          this.entity.district = null;
          this.entity.city = null;
          break;
        case "region":
          if (this.entity.region) {
            this.entity.country = this.entity.region.country;
          }
          this.entity.district = null;
          this.entity.city = null;
          break;
        case "district":
          if (this.entity.district) {
            this.entity.country = this.entity.district.country;
            this.entity.region = this.entity.district.region;
          }
          this.entity.city = null;
          break;
        case "city":
          if (this.entity.city) {
            this.entity.country = this.entity.city.country;
            this.entity.region = this.entity.city.region;
            this.entity.district = this.entity.city.district;
          }
          break;
      }
      this.isChanged = true;
    },
    async submit(closeAfterSubmit) {
      const item = {
        id: this.entity.id,
        countryId: this.entity.country.id,
        cityId: this.entity.city.id,
        code: this.entity.code,
        districtId: this.entity.district ? this.entity.district.id : null,
        regionId: this.entity.region.id,
      };

      if (this.entity.id && this.entity.id > 0) {
        this.loading = true;
        await locationsApi.updateLocation(this.resource, this.entity.id, item);
        this.showInfo("Индекс изменен");
        this.isChanged = false;
        if (closeAfterSubmit) {
          this.$router.go(-1);
        }
        this.loading = false;
      } else {
        this.loading = true;
        const res = await locationsApi.createLocation(this.resource, item);
        this.showInfo("Индекс добавлен");
        this.entity.id = res.data;
        if (this.isModal) {
          NestedEditorsEventBus.$emit("create", this.entity.id);
        } else {
          if (closeAfterSubmit) {
            this.$router.go(-1);
          }
          this.$router.replace(`/${this.resource}/${res.data}`);
        }
        this.loading = false;
      }
    },
    cancel() {
      if (this.isModal) {
        NestedEditorsEventBus.$emit("close");
        return;
      }
      this.$router.go(-1);
    },
    async saveAndClose() {
      await this.submit(true);
    },
    resetLoaders() {
      this.loading = false;
    },
  },
};
</script>
